import axios from 'axios';
import jwtEncode from 'jwt-encode';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5070/api',
});

// Interceptor para firmar peticiones JWT con rol admin para consultar /polls/all
api.interceptors.request.use(
    (config) => {
        const secret = process.env.REACT_APP_API_JWT_SECRET || 'b758f01d-2619-41ce-b2fb-f9222cbe8f44';

        let payload = { id: 1, email: 'trivia@system', role: 'admin' };
        try {
            const userStr = localStorage.getItem('user');
            if (userStr) {
                const user = JSON.parse(userStr);
                payload = { id: user.id, email: user.email, role: user.role || 'admin' };
            }
        } catch (e) {
            console.error('Error parsing local user in focus-trivia', e);
        }

        if (secret) {
            const token = jwtEncode(payload, secret);
            config.headers.Authorization = `Bearer ${token}`;
        } else {
            const oldToken = localStorage.getItem('token');
            if (oldToken) config.headers.Authorization = `Bearer ${oldToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;
